import { useState } from "react";
import Lightbox from "react-image-lightbox";
import styled from "styled-components";
import { generateDamageReport } from "../../../../components/warehouse/damageReporting/utils";
import { Collection } from "../RenderImages";
import { formatEmail, getUserStation } from "../../../../utils";
import moment from "moment";
import useUser from "../../../../customHooks/useUser";
import useAppData from "../../../../customHooks/useAppData";

export default function LightBox({
    lightBoxOpen,
    setLightBoxOpen,
    collection
}: {
    lightBoxOpen: boolean;
    setLightBoxOpen: React.Dispatch<React.SetStateAction<boolean>>;
    collection: Collection;
}) {

    const [photoIndex, setPhotoIndex] = useState(0);

    if (!lightBoxOpen || !collection) {
        return null;
    }

    const { images } = collection;

    return (
        //@ts-ignore
        <Lightbox
            mainSrc={images[photoIndex].url}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={
                images[(photoIndex + images.length - 1) % images.length]
            }
            onCloseRequest={() => setLightBoxOpen(false)}
            onMovePrevRequest={() =>
                setPhotoIndex(
                    (photoIndex + images.length - 1) % images.length
                )
            }
            onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % images.length)
            }
            imageTitle={<h1>{images[photoIndex].title}</h1>}
            imageCaption={(
                <ImageCaption
                    title={images[photoIndex].title}
                    comments={images[photoIndex].comments}
                    createdBy={images[photoIndex].createdBy}
                    createdAt={images[photoIndex].createdAt}
                    url={images[photoIndex].url}
                    collection={collection}
                />
            )}
        />
    );
}

const ImageCaption = ({
    title,
    comments,
    createdBy,
    createdAt,
    url,
    collection
}: {
    title: string;
    comments: string;
    createdBy: string;
    createdAt: string;
    url: string;
    collection: Collection;
}) => {

    const { user } = useUser();
    const { stations } = useAppData();
    const userStation = getUserStation(stations, user);

    const generateReport = (generateType: 'email' | 'print', collection: Collection) => {
        const imagesArray = collection.images.map(item => item.url);
        const { createdBy, createdAt, comments, collectionId } = collection;
        generateDamageReport(
            generateType,
            user,
            userStation,
            createdBy,
            createdAt,
            comments,
            imagesArray,
            title,
            'DAMAGE',
            collectionId,
            // flightNumber,
            // flightDate,
            // setLoading,
        );
    }

    const handleDeleteImage = async (url: string) => {
        // setLoading(true);
        // await deleteImage(url);
        // setLightBoxOpen(false);
        // setLoading(false);
    }


    return (
        <div className="row" style={{ width: '100%' }}>
            <div className="col-12" style={{ width: '100%' }}>
                <h1>
                    {title}: {comments}.{' '}
                    Reported by {formatEmail(createdBy)} at{' '}
                    {moment(createdAt).format(
                        'MM/DD/YYYY HH:mm'
                    )}
                </h1>
            </div>
            <ImageCaptionIconsContainer>
                <div className="bg-warning text-center">
                    <i
                        style={{ fontSize: '48px' }}
                        className="far fa-envelope visual-caption-icon"
                        onClick={() => generateReport('email', collection)}
                    ></i>
                </div>
                <div className="bg-secondary text-center">
                    <i
                        style={{ fontSize: '48px' }}
                        className="fas fa-cloud-download-alt visual-caption-icon"
                        onClick={() => generateReport('print', collection)}
                    ></i>
                </div>
                {
                    Boolean(handleDeleteImage) !== false && (
                        <div className="bg-danger text-center">
                            <i
                                style={{ fontSize: '40px' }}
                                className="fas fa-trash visual-caption-icon"
                                onClick={() => handleDeleteImage(url)}
                            ></i>
                        </div>
                    )
                }
            </ImageCaptionIconsContainer>
        </div>
    );
}

const ImageCaptionIconsContainer = styled.div`
    display: flex;
    width: 100%;

    & div {
        flex: 1;
    }
`;